var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLuggage1616 = function SvgLuggage1616(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#33A1FC",
    d: "M6 17q-.604 0-1.052-.417a1.34 1.34 0 0 1-.448-1.02V6.5q0-.619.44-1.06A1.44 1.44 0 0 1 5.997 5h1.498V3.5q0-.62.44-1.06A1.45 1.45 0 0 1 9 2h2q.619 0 1.06.44.44.44.44 1.058v1.497H14q.619 0 1.06.44.44.44.44 1.065v9.042q0 .6-.448 1.03Q14.604 17 14 17v.104a.86.86 0 0 1-.26.639.85.85 0 0 1-.615.257.85.85 0 0 1-.615-.258.86.86 0 0 1-.26-.638V17h-4.5v.125a.85.85 0 0 1-.258.615.86.86 0 0 1-.638.26.8.8 0 0 1-.608-.26.87.87 0 0 1-.246-.615zm1.75-3.25a.75.75 0 0 0 1.5 0v-5.5a.75.75 0 0 0-1.5 0zm3 0a.75.75 0 0 0 1.5 0v-5.5a.75.75 0 0 0-1.5 0zM9 5h2V3.5H9z"
  })));
};
export default SvgLuggage1616;